import { Wallet, Building2, Landmark, CreditCard, Smartphone, Banknote, PiggyBank } from 'lucide-react';

export const getAccountIcon = (name) => {
  const lowerName = name?.toLowerCase() || '';
  if (lowerName.includes('momo') || lowerName.includes('mobile')) return <Smartphone className="w-5 h-5 text-yellow-600" />;
  if (lowerName.includes('bank') || lowerName.includes('equity') || lowerName.includes('kigali')) return <Building2 className="w-5 h-5 text-blue-600" />;
  if (lowerName.includes('cash')) return <Banknote className="w-5 h-5 text-green-600" />;
  return <PiggyBank className="w-5 h-5 text-purple-600" />;
};

export const getCategoryIcon = (category) => {
  switch(category) {
    case 'MoMo': return <Wallet className="w-4 h-4 text-yellow-600" />;
    case 'Equity Bank': return <Building2 className="w-4 h-4 text-red-600" />;
    case 'Bank of Kigali': return <Landmark className="w-4 h-4 text-blue-600" />;
    case 'Cash': return <CreditCard className="w-4 h-4 text-green-600" />;
    default: return <Wallet className="w-4 h-4 text-gray-600" />;
  }
};

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CAPITAL_CATEGORIES = ['Initial Capital', 'Additional Investment', 'Owner Withdrawal', 'Owner Distribution'];
export const TRANSFER_ACCOUNTS = ['MoMo', 'Equity Bank', 'Bank of Kigali', 'Cash'];
